import React, { useState } from "react";

const ToggleSwitch = ({ initialState = false, 
  onLabel = "Active", offLabel = "Inactive", onChange }) => {
  const [isChecked, setIsChecked] = useState(initialState);

  const handleToggle = (e) => {
    e.stopPropagation();
    const newState = !isChecked;
    setIsChecked(newState);
    if (onChange) {      
      onChange(newState);
    }
  };

  return (
    <label style={styles.toggleSwitch}>
      <input type="checkbox" checked={isChecked} 
      onChange={handleToggle} 
      style={styles.input} />
      <span style={{ ...styles.slider, backgroundColor: isChecked ? "#4caf50" : "#ccc" }}>
        <span style={{
          ...styles.circle,
          transform: isChecked ? "translateX(14px)" : "translateX(0)"
        }}></span>
      </span>
      <span style={styles.label}>{isChecked ? onLabel : offLabel}</span>
    </label>
  );
};

const styles = {
  toggleSwitch: {
    display: "flex",
    justifyContent: "end",
    alignItems: "center",
    cursor: "pointer",
    gap: "8px"
  },
  input: {
    display: "none"
  },
  slider: {
    width: "30px",
    height: "16px",
    borderRadius: "16px",
    position: "relative",
    transition: "0.3s"
  },
  circle: {
    content: "" ,
    width: "12px",
    height: "12px",
    background: "white",
    position: "absolute",
    top: "2px",
    left: "2px",
    borderRadius: "50%",
    transition: "0.3s"
  },
  label: {
    fontSize: "14px",
    fontWeight: "bold"
  }
};

export default ToggleSwitch;
